import type { SearchResponseDTO } from '../../../shared/api/magellan/search/dto';

const TENDER_ITEM_HEIGHT = 68;
const BUYER_ITEM_HEIGHT = 44;
const BUFFER_HEIGHT = 100;
const EMPTY_SECTION_HEIGHT = 48;

export const useSearchResultContentHeight = (
  data: SearchResponseDTO | undefined,
) => {
  if (!data) {
    return 0;
  }
  const { tenders, buyers } = data;
  const tenderHeight =
    tenders.length * TENDER_ITEM_HEIGHT || EMPTY_SECTION_HEIGHT;
  const buyerHeight = buyers.length * BUYER_ITEM_HEIGHT || EMPTY_SECTION_HEIGHT;
  const totalHeight = tenderHeight + buyerHeight + BUFFER_HEIGHT;

  return totalHeight;
};
